<template>
  <div class="w3-container w3-responsive">

    <!-- 加载状态 -->
    <div v-if="loading" class="w3-panel w3-blue w3-display-container">
      <span class="w3-button w3-large w3-display-topright" @click="loading = false">×</span>
      <p>加载中...</p>
    </div>

    <!-- 错误提示 -->
    <div v-if="error" class="w3-panel w3-red">
      <p>{{ error }}</p>
    </div>

    <!-- 数据列表 -->
    <table class="w3-table w3-striped w3-bordered w3-border w3-hoverable w3-white">
      <thead>
        <tr class="w3-blue">
          <th>变动时间</th>
          <th>变动值</th>
          <th>变动原因</th>
          <th>变动后余额</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in list" :key="item.RecordId" class="w3-padding">
          <td class="w3-text-grey">{{ $filters.formatDate(item.ChangeDate) }}</td>
          <td class="w3-text-grey">{{ $filters.formatNumber(item.CoinChange) }}</td>
          <td class="w3-text-grey">{{ item.ChangeTypeInfo }}</td>
          <td class="w3-text-grey">{{ $filters.formatNumber(item.AfterCoin) }}</td>
        </tr>
        <tr>
          <td colspan="4" class="w3-text-grey w3-center">共 {{ list.length }} 条记录</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  data() {
    return {
      list: [],
      loading: false,
      error: '',
      userName: '',
      userPass: ''
    };
  },
  created() {

    const query = this.$route.query;

    if (query.u && query.p) {
      sessionStorage.setItem('userName', query.u);
      sessionStorage.setItem('userPass', query.p);
    }
    this.userName = sessionStorage.getItem('userName');
    this.userPass = sessionStorage.getItem('userPass');
    if (this.userName && this.userPass) {
      this.fetchData();
    } else {
      this.$router.push('/login');
    }
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.error = '';
      try {

          const response = await fetch(`${this.$apiUrl}/getCoinRecord`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              username: this.userName,
              t: this.userPass
            })
          });

        const data = await response.json();

        if (data.code !== 200) {
          this.error = data.msg;
          this.$router.push('/login?err=1');
          return;
        }
        this.list = data.result;
      } catch (err) {
        this.error = '获取数据失败，请稍后重试。';
        console.error(err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
/* 可选：添加自定义样式覆盖或补充 W3.CSS */
.w3-container {
  margin: 0px auto;
  padding: 0px;
}

.w3-ul li {
  transition: background-color 0.3s;
}

.w3-ul li:hover {
  background-color: #f0f0f0;
}
</style>